export const settings = {

	email_regex: '^[0-9,a-z,A-Z,á,é,í,ó,ú,â,ê,ô,ã,õ,ç,Á,É,Í,Ó,Ú,Â,Ê,Ô,Ã,Õ,Ç,ü,ñ,Ü,Ñ\\-\\+_]+(\\.[\\w]+)*@[0-9,a-z,A-Z,á,é,í,ó,ú,â,ê,ô,ã,õ,ç,Á,É,Í,Ó,Ú,Â,Ê,Ô,Ã,Õ,Ç,ü,ñ,Ü,Ñ\\-]+(\\.[\\w]+)*(\\.[a-z]{2,})$',
	date_regex: '([12]\\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\\d|3[01]))',//YYYY-MM-DD
	birthdate_regex: '((0[1-9]|1[0-2])/(0[1-9]|[12]\\d|3[01])/[12]\\d{3})',//MM/DD/YYYY
	//name_regex: '^[a-zA-Z\\s.,\'-]*$',
	name_regex: '^[a-z,A-Z,á,é,í,ó,ú,â,ê,ô,ã,õ,ç,Á,É,Í,Ó,Ú,Â,Ê,Ô,Ã,Õ,Ç,ü,ñ,Ü,Ñ\\s.,\'-]*$',
	occupation_regex: '^[0-9,a-z,A-Z,á,é,í,ó,ú,â,ê,ô,ã,õ,ç,Á,É,Í,Ó,Ú,Â,Ê,Ô,Ã,Õ,Ç,ü,ñ,Ü,Ñ\\s.,\'-, ]*$',
	address_regex: '^[0-9,a-z,A-Z,á,é,í,ó,ú,â,ê,ô,ã,õ,ç,Á,É,Í,Ó,Ú,Â,Ê,Ô,Ã,Õ,Ç,ü,ñ,Ü,Ñ\\s.,\'-, ]*$',
	message_regex: '^[0-9,a-z,A-Z,á,é,í,ó,ú,â,ê,ô,ã,õ,ç,Á,É,Í,Ó,Ú,Â,Ê,Ô,Ã,Õ,Ç,ü,ñ,Ü,Ñ\\s.,\'-, ]*$',
	mobile_regex: '^[0-9-() ]*$',
	fname_max_length: 60,
	lname_max_length: 60,
	mobile_max_length: 30,
	email_max_length: 50,
	occupation_max_length: 30,
	address_max_length: 150,
	name_max_length: 60,
	
	google_site_key: '6Ld5n8YUAAAAABn6dTToCLq1UaEeacTURCmnQoFD',
	google_secret_key: '6Ld5n8YUAAAAAM3A0IKWF3yYfiZw6VEULjcV8uZi',
}
